// extracted by mini-css-extract-plugin
export default {"root":"_2rDc-","left":"_17hAd","right":"_1VUUF"};